<template>
  <div class="relative-pull d2-mt-20">
    <el-form class="d2-mt-20 d2-mr-20" ref="searchForm" :model="searchForm" size="small" :label-width="formLabelWidth"
      @submit.native.prevent>
      <el-row>
        <el-col :span="6">
          <el-form-item prop="StationName" label="分站">
            <el-select v-model="searchForm.StationName" class="w100" @change="handlesearch">
              <el-option v-for="item in StationNameList" :key="item.Name" :label="item.Name" :value="item.Name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="show">
          <el-form-item prop="City" label="城市">
            <el-select v-model="searchForm.City" class="w100" @change="handlesearch">
              <el-option v-for="item in CityList" :key="item.ID" :label="item.City" :value="item.City">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="show">
          <el-form-item prop="Depart" label="部门">
            <el-select v-model="searchForm.Depart" class="w100" @change="handlesearch">
              <el-option v-for="item in DepartList" :key="item.Name" :label="item.Name" :value="item.Name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="show">
          <el-form-item prop="WorkUnit" label="办事处">
            <el-select v-model="searchForm.WorkUnit" class="w100" @change="handlesearch">
              <el-option v-for="item in WorkUnitList" :key="item.Name" :label="item.Name" :value="item.Name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="show">
          <el-form-item prop="Position" label="职务">
            <el-select v-model="searchForm.Position" class="w100" @change="handlesearch">
              <el-option v-for="item in PositionList" :key="item.Name" :label="item.Name" :value="item.Name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="关键词">
            <el-input placeholder="请输入姓名、AD账号等关键字搜索" v-model="searchForm.keyWords" clearable
              @keyup.enter.native="handlesearch" class="w100">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
             <el-link class="d2-mr-10" type="primary" @click="show=!show">{{show==false?'展开':'收起'}}<i :class="show==false?'el-icon-arrow-down':'el-icon-arrow-up'"></i></el-link>
            <el-button :loading="loading" type="primary" icon="el-icon-search" @click="handlesearch()">搜索</el-button>
            <el-button icon="el-icon-refresh-left" @click="Reset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="sec_box d2-mt-10" v-loading="loading">
      <template v-if="ListData.length != 0">
        <el-col :span="24" v-for="(item, index) in ListData" :key="index" :title="item.Title">
          <div class="header_box d2-mb-20">
            <span></span>{{item.key}}
          </div>
          <el-table :data="item.value" style="width: 97%;margin: 0px 1.5% 1%;" border stripe>
            <el-table-column prop="MemberName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="MemberCode" label="AD账号" align="center"></el-table-column>
            <!-- <el-table-column prop="Mobile" label="联系方式" align="center"></el-table-column> -->
            <el-table-column prop="Email" label="邮箱" align="center"></el-table-column>
            <el-table-column prop="WorkUnit" label="办事处" align="center"></el-table-column>
            <el-table-column prop="Depart" label="部门" align="center"></el-table-column>
            <el-table-column prop="Position" label="代表角色" align="center"></el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24" class="align-center mt-20 d2-mb-20">
          <span class="no_more">没有更多了~</span>
        </el-col>
      </template>
      <template v-else>
        <el-empty class="auto"></el-empty>
      </template>
    </el-row>
  </div>
</template>

<script>
  import * as indexService from "@/api/sys/index";
  import _ from "lodash";
  export default {
    name: "listRoster",
    data() {
      return {
        searchForm: {
          keyWords: "",
          WorkUnit: '',
          City: '',
          Depart: '',
          StationName: '',
          Position: ''
        },
        PositionList: [],
        CityList: [],
        DepartList: [],
        StationNameList: [],
        WorkUnitList: [],
        show: false,
        formLabelWidth: "100px",
      };
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      ListData: {
        type: Array,
        required: false,
        default: () => [],
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    created() {
      this.getSearchData();
    },
    mounted() {},
    methods: {
      getSearchData() {
        let actionTpyes = [
          "办事处视图",
          "定制_城市选择",
          "部门信息列表",
          "分站视图_工会小组选择用",
          "人员职务视图",
        ];
        for (var i = 0; i < actionTpyes.length; i++) {
          let parmas = {
            viewName: actionTpyes[i]
          }
          indexService.GetSearchList(parmas).then((data) => {
            if (parmas.viewName == '人员职务视图') {
              this.PositionList = data.data;
            } else if (parmas.viewName == '定制_城市选择') {
              this.CityList = data.data;
            } else if (parmas.viewName == '部门信息列表') {
              this.DepartList = data.data;
            } else if (parmas.viewName == '分站视图_工会小组选择用') {
              this.StationNameList = data.data;
            } else if (parmas.viewName == '办事处视图') {
              this.WorkUnitList = data.data;
            }
          });
        }
      },
      handlesearch: _.debounce(
        function (search) {
          this.pageIndex = 0;
          this.$emit("search", this.pageIndex,this.searchForm);
        },
        1000, {
          leading: true,
          trailing: false,
        }
      ),
      Reset() {
        this.searchForm.keyWords = ''
        this.searchForm.WorkUnit = ''
        this.searchForm.City = ''
        this.searchForm.Depart = ''
        this.searchForm.StationName = ''
        this.searchForm.Position = ''
        this.pageIndex = 0;
        this.$emit("search", this.pageIndex,this.searchForm);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";

  /deep/ .el-dialog__body {
    padding: 5px 20px;
  }

  .el-table th.el-table__cell>.cell {
    color: #333;
  }
</style>